(ns ui.components.modal.style
  (:require))

(def sizes
  [::lg
   ::full
   ::md])

(def size-lg ::lg)
(def size-md ::md)

;; DON't remove css due it effects many places

(defn footer-left-container
  []
  {:display         "flex"
   :gap             "8px"
   :justify-content "start"
   :align-content   "center"
   :align-items     "center"                                                                        ;
   :flex-direction  "row"})

(defn footer-right-container
  []
  {:display         "flex"
   :gap             "8px"
   :justify-content "end"
   :flex            "1 1 auto"
   :align-content   "center"
   :align-items     "center"                                                                        ;
   :flex-direction  "row"})

(defn footer-center-container
  []
  {:flex            "1 1 auto"
   :display         "flex"
   :justify-content "center"
   :align-content   "center"
   :align-items     "center"                                                                        ;
   :flex-direction  "row"})


